module.exports = __webpack_public_path__ + "static/img/yahav.a8c0963.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/yahav.jpg
// module id = +YWj
// module chunks = 6